import React, { useEffect, useState,useCallback, useRef } from "react";
import EmlAthnNoSendApi from "Apis/EmlAthnNoSendApi";
import EmlAthnNoVrfRqstApi from "Apis/EmlAthnNoVrfRqstApi";
import EmlAddrDupChkApi from "Apis/EmlAddrDupChkApi";
import CptchUi from "./CptchUi";
import { Helmet } from 'react-helmet-async';
import useRecaptcha from 'Utils/useRecaptcha';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { validateInput } from './XssFilter';
import { useAsyncAction } from 'hooks/useAsyncAction';
import ApiError from "./ApiError";
import ApiResultModal from "Components/ApiResultModal";

const EmlAthnPopUi = () => {
    const url = new URL(window.location.href);
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const emlAthnPrpsCd:any = url.searchParams.get("emlAthnPrpsCd");
    const [emlAddrDopChkVal,setEmlAddrDopChkVal] = useState("");
    const [emlAddrDopChkLbl,setEmlAddrDopChkLbl] = useState("");
    const [emlAthnChkLbl,setEmlAthnChkLbl] = useState("");
    const [emlAthnNoTimer,setEmlAthnNoTimer] = useState<number>(0);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const { getToken } = useRecaptcha();
    const timerInterval = 1000;
    const timerMinutes = String(Math.floor((emlAthnNoTimer / (1000 * 60)) % 60)).padStart(2, '0');
    const timerSecond = String(Math.floor((emlAthnNoTimer / 1000) % 60)).padStart(2, '0');
    const emlRole = /^[a-zA-Z0-9+-\_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const emlAthnNoRole = /^[0-9]{6}$/;

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    useEffect(() => {
        if (emlAthnPrpsCd == null) {
            openResultModal("비정상 접근" + emlAthnPrpsCd, () => {
                window.close();
            });
        }
    }, [emlAthnPrpsCd]);
    
    const [membEml,setMembEml] = useState('');
    const [authNoVal,setAuthNoVal] = useState('');

    const resetResultLabels = () => {
        setEmlAddrDopChkLbl("");
        setEmlAthnChkLbl("");
    };

    const MembEmlHandler = (event:any) => {
        setEmlAddrDopChkVal("");
        resetResultLabels();
        setMembEml(validateInput(event.currentTarget.value, 'email', false));
    }
    const AuthNoValHandler = (event:any) => {
        setEmlAthnChkLbl("");
        const value = event.currentTarget.value;
        // XSS 필터링 후 숫자만 입력 허용, 최대 6자리 - 패턴 제거 없이 감지만
        const filteredValue = validateInput(value, 'basic', false);
        const numericValue = filteredValue.replace(/[^0-9]/g, '').slice(0, 6);
        setAuthNoVal(numericValue);
    }
    // 특정 목적 코드용 이메일 존재 확인 후 인증번호 발송 비동기 함수
    const performSpecialAuthSend = async (membEml: string, emlAthnPrpsCd: string) => {
        const token = await getToken('email_auth');
        const resp = await EmlAddrDupChkApi(membEml, token);
        
        if(resp.apiHdr.code == "COMM0000") {
            if(resp.apiBody.yn =="N") {
                setEmlAddrDopChkLbl("찾을 수 없는 이메일입니다.");
                // 가입하지 않은 이메일입니다.
            } else if (resp.apiBody.yn == "Y") {
                // 이메일이 존재하면 인증번호 발송으로 진행
                await performNormalAuthSend(membEml, emlAthnPrpsCd);
            }
        }
        else {
            ApiError(langData, resp.apiHdr.code);
        }
    };

    // 일반 인증번호 발송 비동기 함수
    const performNormalAuthSend = async (membEml: string, emlAthnPrpsCd: string) => {
        const token = await getToken('email_auth');
        const resp = await EmlAthnNoSendApi(membEml, emlAthnPrpsCd, token);
        
        if(resp.apiHdr.code == "ATHN2122") {
            setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_NO_INPUT_DESC_02}`);
        } else {
            setEmlAthnNoTimer((resp.apiBody.exprTime)*1000);
        }
    };

    // 중복 호출 방지를 위한 useAsyncAction 적용
    const executeSpecialAuthSend = useAsyncAction(performSpecialAuthSend);
    const executeNormalAuthSend = useAsyncAction(performNormalAuthSend);

    const EmlAthnSendFunc = () => {
        resetResultLabels();
        switch(emlAthnPrpsCd) {
            case "OTP_REG":
            case "PWD_RSET":
            case "PWD_RSET_MYPAGE":
            case "OTP_UNREG":
            case "OTP_UNREG_MYPAGE":
            case "PASSWD_CHNG":
            case "EML_CHNG_ATHN":
            case "MEMB_FIND":
            case "MEMB_LVD":
            case "SCND_PWD_RSET":
                if(!emlRole.test(membEml)) {
                    return setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_02}`);
                    // 올바르지 않은 이메일 형식입니다.
                }else {
                    executeSpecialAuthSend(membEml, emlAthnPrpsCd);
                }
            break;
            default:
                if(emlAddrDopChkVal !="N") {
                    return setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_01}`);
                    // 이메일 중복확인을 해주세요.
                }else {
                    executeNormalAuthSend(membEml, emlAthnPrpsCd);
                }
            break;
        }
    }
    // 이메일 인증번호 검증 비동기 함수
    const performEmailAuthVerification = async (authNoVal: string) => {
        const token = await getToken('email_verify');
        const resp = await EmlAthnNoVrfRqstApi(authNoVal, token);
        
        if(resp.apiBody !=null && resp.apiBody.athnPrpsCd !=null) {
            setEmlAthnChkLbl("");
            window.opener.emlAthnRespFunc(resp.apiBody.athnPrpsCd, membEml);
            window.close();
        }
        if(resp.apiHdr.code == "ATHN2100") {
            setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_NO_INPUT_DESC_01}`);
        }
        if(resp.apiHdr.code !="ATHN0000" && resp.apiHdr.code != "ATHN2100") {
            setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_NO_INPUT_DESC_01}  ${resp.apiHdr.code}`);
        }
    };

    // 중복 호출 방지를 위한 useAsyncAction 적용
    const executeEmailAuthVerification = useAsyncAction(performEmailAuthVerification);

    const EmlAthnVrfFunc = (authNoVal:string) => {
        setEmlAthnChkLbl("");
        if(membEml == "" ) {
            return setEmlAthnChkLbl(`${langData&&langData.MEMB_JOIN_ALL_AGRE_BTN_00}`);
            // 이메일을 입력해주세요.
        }
        switch(emlAthnPrpsCd) {
            case "MEMB_JOIN":
                if(emlAddrDopChkVal != "N") {
                    return setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_01}`);
                    // 이메일 중복확인을 해주세요.
                }
            break;
            default:
                
            break;
        }

        if(!emlAthnNoRole.test(authNoVal)) {
            setEmlAthnChkLbl(`${langData&&langData.EML_ATHN_NO_INPUT_DESC_01}`);
            // 인증번호가 올바르지 않습니다.
        }else {
            executeEmailAuthVerification(authNoVal);
        }
    }
    // 이메일 중복 확인 비동기 함수
    const performEmailDupCheck = async (membEml: string) => {
        const token = await getToken('email_dup');
        const resp = await EmlAddrDupChkApi(membEml, token);
        
        switch(resp.apiHdr.code) {
            case "COMM0000":
                setEmlAddrDopChkVal(resp.apiBody.yn);
                if(resp.apiBody.yn =="N") {
                    setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_04}`);
                    // 사용 가능한 이메일 입니다.
                }else {
                    setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_03}`);
                    // 이미 사용중인 이메일 입니다.
                }
                break;
            default:
                ApiError(langData,resp.apiHdr.code);
                return;
        }
    };

    // 중복 호출 방지를 위한 useAsyncAction 적용
    const executeEmailDupCheck = useAsyncAction(performEmailDupCheck);

    const EmlAddrDupChkFunc = (membEml:string) => {
        resetResultLabels();
        if(!emlRole.test(membEml)) {
            setEmlAddrDopChkLbl(`${langData&&langData.EML_ATHN_EML_INPUT_LBL_02}`);
            //올바르지 않은 이메일 형식입니다.
        }else {
            executeEmailDupCheck(membEml);
        }
    }
    
    useEffect(() => {
        let EmlAthnTimerFunc: NodeJS.Timeout | null = null;
        
        if (emlAthnNoTimer > 0) {
            EmlAthnTimerFunc = setInterval(() => {
                setEmlAthnNoTimer((prevTime) => {
                    const newTime = prevTime - timerInterval;
                    if (newTime <= 0) {
                        return 0;
                    }
                    return newTime;
                });
            }, timerInterval);
        }
        
        return () => {
            if (EmlAthnTimerFunc) {
                clearInterval(EmlAthnTimerFunc);
            }
        };
    }, [emlAthnNoTimer]);
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.EML_ATHN_POP_MAIN_TITL_00}`}</title>
        </Helmet>
        <div className="emlAthnImgWrap">
            <img className="emlAthnImg" src={process.env.PUBLIC_URL + "/images/EmlAthnIcon.png"} alt="" />
        </div>
        <h1>{langData&&langData.EML_ATHN_POP_MAIN_TITL_00}</h1>
        <div className="emailInputWrap mt35">
            <p>{langData&&langData.EML_ATHN_EML_INPUT_TITL_00}</p>
            {/* 이메일 */}
            <div className="relative mt10">
                <input type="text" placeholder={langData&&langData.EML_ATHN_EML_INPUT_DESC_00} onChange={MembEmlHandler} />
                {/* 이메일을 입력해주세요 */}
                { emlAthnPrpsCd =="MEMB_JOIN"||emlAthnPrpsCd =="EML_CHNG" ? 
                    <button className="emlDupChkBtn" onClick={() => EmlAddrDupChkFunc(membEml)}>
                        <p>{langData&&langData.EML_ATHN_EML_DOP_BTN_00}</p>
                        {/* 중복 확인 */}
                    </button>
                    :
                    <></>
                }
                
                <p className={emlAddrDopChkLbl==`${langData&&langData.EML_ATHN_EML_INPUT_LBL_04}`?"emlDupChkLbl active":"emlDupChkLbl"}>{emlAddrDopChkLbl}</p>
                {/* 사용 가능한 이메일 입니다. */}
                
            </div>
            {emlAthnNoTimer > 0?
                <div>
                    <button className="mt35" onClick={EmlAthnSendFunc}>
                        <p>{langData&&langData.EML_ATHN_NO_SEND_BTN_01}</p>
                       {/* 인증번호 */}
                    </button>
                </div>:
                <button className="mt35" onClick={EmlAthnSendFunc}>
                    <p>{langData&&langData.EML_ATHN_NO_SEND_BTN_00}</p>
                    {/* 인증번호 받기 */}
                </button>

            }
        </div>
        <div className="emailInputWrap">
            <p>{langData&&langData.EML_ATHN_NO_INPUT_TITL_00}</p>
            <div className="relative mt10">
                <input 
                    type="text" 
                    placeholder={langData&&langData.EML_ATHN_NO_INPUT_DESC_00} 
                    value={authNoVal}
                    onChange={AuthNoValHandler}
                    maxLength={6}
                />
                {/* 인증번호를 입력해주세요. */}
                {emlAthnNoTimer > 0?
                    <p className="timer">{timerMinutes}:{timerSecond}</p>:
                    <></>
                }
                <p className="emlDupChkLbl">{emlAthnChkLbl}</p>
            </div>
        </div>
        <button className="athnBtn" onClick={()=>EmlAthnVrfFunc(authNoVal)}>
            <p>{langData&&langData.EML_ATHN_NO_ATHN_BTN_00}</p>
            {/* 인증하기 */}
        </button>
        <div className="capthCpyr">
        </div>
        {/* reCAPTCHA provided at app root; tokens requested via useRecaptcha hook */}
        </>
    )
}

export default EmlAthnPopUi;